let route = [
    {
        path: 'message/index',
        name: '留言管理',
        component: () => import('@/view/message/index')
    },
]

export default route